import { isString, map } from 'lodash';
import { getYear } from 'date-fns';
import { StringHelpers } from '@lockton-apps/shared/util/helpers';

export const defaultInterpolationArgs: Record<string, any> = {
  currentYear: getYear(new Date()),
};

export function defaultInterpolation(
  source: string | string[] | undefined,
  args = defaultInterpolationArgs
): string | string[] {
  if (isString(source)) {
    return StringHelpers.interpolate(source, args, true);
  }

  return map(source, (item: string) =>
    item ? StringHelpers.interpolate(item, args, true) : item
  );
}
